/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, Events, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
declare var Highcharts: any;
/// *** Custom import ***///
import { Globals } from '../../../../app/globals';
import { SessionProvider } from '../../../../providers/session';
import { Market_SessionInstrumentStore } from '../sessionInstrument.store';

@Component({
  selector: 'page-market-sessionInstrument-intraday',
  templateUrl: 'intraday.html'
})
export class Market_SessionInstrumentIntradayPage {
  @ViewChild(Content) private content: Content;
  private chart: any;
  constructor(
    // *** System
    private events: Events,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private store: Market_SessionInstrumentStore) {
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this._buildChart();
      this._eventsSub();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillLeave() {
    try {
      this._eventsUnsub();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Construire le chart de l'intraday
  private _buildChart() {
    this.chart = new Highcharts.stockChart('chartContainer', {
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false
      },
      xAxis: {
        gapGridLineWidth: 0,
        labels: {
          format: '{value:%H:%M}',
        }
      },
      rangeSelector: {
        buttons: [{
          type: 'hour',
          count: 1,
          text: '1h'
        }, {
          type: 'all',
          count: 1,
          text: 'Tout'
        }],
        selected: 2,
        inputEnabled: false
      },
      series: [{
        type: 'area',
        lineWidth: 1,
        tooltip: {
          borderRadius: 0,
          headerFormat: '<span style="font-size: 10px">{point.key}</span><br\>',
          pointFormat: '<span style="font-size: 10px;font-weight: bold;">{point.y}</span>',
          xDateFormat: '%H:%M:%S',
          valueDecimals: 2
        },
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: [
            [0, Highcharts.getOptions().colors[0]],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
          ]
        },
        threshold: null
      }],
    });
  }

  // *** S'inscrire aux évènements
  private _eventsSub() {
    // On 'resetInstrumentInfos'
    this.events.subscribe('Market_SessionInstrumentStore.reset', eventData => {
      this.chart['series'][0].setData([]);
    });
    // On 'loadInstrumentInfos'
    this.events.subscribe('Market_SessionInstrumentStore.load', eventData => {
      this.chart['series'][0].setData(this.store.activeSessionInstrument.intraday);
      this.content.resize();
    });
  }

  // *** S'inscrire aux évènements
  private _eventsUnsub() {
    this.events.unsubscribe('Market_SessionInstrumentStore.reset');
    this.events.unsubscribe('Market_SessionInstrumentStore.load');
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/sessionInstrument/intraday/intraday.ts